<template>
    <FormSection title="Clinical Information" :full-height="false" :application-id="application">
        <template #content>
            <section class="col-12 px-2 my-2">
                <section class="row col-10 offset-md-1 col-md-11">
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Care Team <span class="text-danger">*</span></label>
                        <select
                            class="form-select"
                            v-model="patientDetails.careTeamId"
                            @blur="v$.patientDetails.careTeamId.$touch()"
                            @change="handleCareTeamChange"
                        >
                            <option :value="null">Select Care Team</option>
                            <option v-for="team of teams" :key="team.id" :value="team.id">{{ team.name }}</option>
                        </select>
                        <span v-if="v$.patientDetails.careTeamId.$error" class="field-invalid"
                            >Care Team is required.</span
                        >
                    </div>
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Case Manager </label>
                        <TypeaheadInput
                            :getData="getUsersList"
                            :value="caseManager"
                            v-on:valueChanged="updateCaseManager"
                            placeholder="Start Typing..."
                        >
                        </TypeaheadInput>
                    </div>
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Clinical Manager <span class="text-danger">*</span></label>
                        <span class="shimmer-loading" v-if="loading"></span>
                        <TypeaheadInput
                            v-else
                            :getData="getUsersList"
                            :value="clinicalManager"
                            v-on:valueChanged="updateClinicalManager"
                            placeholder="Start Typing..."
                            v-on:blurredInput="v$.patientDetails.clinicalManagerId.$touch"
                        >
                        </TypeaheadInput>
                        <span v-if="v$.patientDetails.clinicalManagerId.$error" class="field-invalid"
                            >Clinical Manager is required.</span
                        >
                    </div>
                </section>
                <section class="row col-10 offset-md-1 col-md-11">
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Admitting RN </label>
                        <TypeaheadInput
                            :getData="getUsersList"
                            :value="admittingRN"
                            v-on:valueChanged="updateAdmittingRN"
                            placeholder="Start Typing..."
                        >
                        </TypeaheadInput>
                    </div>
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Spiritual Care Counselor </label>
                        <TypeaheadInput
                            :getData="getUsersList"
                            :value="spiritualCounselor"
                            v-on:valueChanged="updateSpiritualCounselor"
                            placeholder="Start Typing..."
                        >
                        </TypeaheadInput>
                    </div>
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Social Worker </label>
                        <TypeaheadInput
                            :getData="getUsersList"
                            :value="socialWorker"
                            v-on:valueChanged="updateSocialWorker"
                            placeholder="Start Typing..."
                        >
                        </TypeaheadInput>
                    </div>
                </section>
                <section class="row col-10 offset-md-1 col-md-11">
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Hospice Aide</label>
                        <TypeaheadInput
                            :getData="getActiveList"
                            :value="hospiceAide"
                            v-on:valueChanged="updateHospiceAide"
                            placeholder="Start Typing..."
                        >
                        </TypeaheadInput>
                    </div>
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Volunteer Coordinator </label>
                        <TypeaheadInput
                            :getData="getActiveList"
                            :value="volunteerCoordinator"
                            v-on:valueChanged="updatevolunteerCoordinator"
                            placeholder="Start Typing..."
                        >
                        </TypeaheadInput>
                    </div>
                    <div class="form-group col-3">
                        <label for="patient-middle-initial"> Bereavement Coordinator </label>
                        <TypeaheadInput
                            :getData="getActiveList"
                            :value="bereavementCoordinator"
                            v-on:valueChanged="updatebereavementCoordinator"
                            placeholder="Start Typing..."
                        >
                        </TypeaheadInput>
                    </div>
                    <div class="col-12 1 col-md-9 row">
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Referral Diagnosis </label>
                            <Diagnosis
                                :selected-diagnosis="referralDiagnosis"
                                classes="d-inline-block w-100"
                                :diagnosis-changed="referralDiagnosisChanged"
                                :application="Number(application)"
                            ></Diagnosis>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial">Admitting Diagnosis </label>
                            <Diagnosis
                                :selected-diagnosis="admittingDiagnosis"
                                classes="d-inline-block w-100"
                                :diagnosis-changed="admittingDiagnosisChanged"
                                :application="Number(application)"
                            ></Diagnosis>
                        </div>
                    </div>
                    <div class="row col-10 col-md-11">
                        <div class="form-group col-12 col-md-3">
                            <label for="tolerable-pain-level"> Tolerable Pain Level </label>
                            <select
                                name="tolerable-pain-level"
                                class="form-select"
                                v-model="patientDetails.tolerablePainLevel"
                            >
                                <option :value="null">Select Tolerable Pain Level</option>
                                <option
                                    v-for="painLevel in TolerablePainLevels"
                                    :key="`${painLevel.name}-${painLevel.value}`"
                                    :value="painLevel.value"
                                >
                                    {{ painLevel.value }} - {{ painLevel.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 pe-4">
                        <HospiceDiagnosisTable
                            :diagnosis="patientDetails.diagnoses"
                            :updateDiagnosis="updateDiagnosis"
                            :patientDetails="patientDetails"
                            :id="patientDetails.id"
                            :patientId="patientId"
                            :accountId="accountId"
                        />
                    </div>
                </section>
            </section>
        </template>
    </FormSection>
</template>

<script src="./ClinicalInformation.ts"></script>
